import { render, staticRenderFns } from "./SimSection.vue?vue&type=template&id=1fd99a6c&scoped=true"
import script from "./SimSection.vue?vue&type=script&lang=js"
export * from "./SimSection.vue?vue&type=script&lang=js"
import style0 from "./SimSection.vue?vue&type=style&index=0&id=1fd99a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd99a6c",
  null
  
)

export default component.exports